import { LOGO_URL } from "@/constants";

export const LogoMark = ({ size = 40 }) => (
  <span
    className="inline-block bg-black overflow-hidden shrink-0"
    style={{ width: size, height: size }}
    aria-label="Matrix Works Gold logo"
  >
    <img
      src={LOGO_URL}
      alt=""
      style={{
        width: size * 2.1,
        maxWidth: "none",
        marginLeft: -size * 0.55,
        marginTop: -size * 0.17,
      }}
    />
  </span>
);

export const Logo = ({ size = 40, dark = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark size={size} />
    <div className="leading-none">
      <div className={`font-display font-bold text-lg tracking-tight ${dark ? "text-white" : "text-[#1A1A1A]"}`}>
        Matrix Works
      </div>
      <div className="text-[10px] tracking-[0.25em] uppercase text-[#B5952F] font-semibold mt-1">
        Gold · Service Pvt. Ltd.
      </div>
    </div>
  </div>
);
